import { render } from "./DashboardQuotesChart.vue?vue&type=template&id=837b4ea6&scoped=true"
import script from "./DashboardQuotesChart.vue?vue&type=script&lang=js"
export * from "./DashboardQuotesChart.vue?vue&type=script&lang=js"

import "./DashboardQuotesChart.vue?vue&type=style&index=0&id=837b4ea6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-837b4ea6"]])

export default __exports__